
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * LevelType enum
 */
class LevelType {
  /**
   * Initialize enum with a given value
   * @param {LevelType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof LevelType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!LevelType}
   * @param {!LevelType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof LevelType)) {
      throw new TypeError('Instance of LevelType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!LevelType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!LevelType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === LevelType.NONE.value) {
      return 'NONE'
    }
    if (this.value === LevelType.MARGIN_CALL.value) {
      return 'MARGIN_CALL'
    }
    if (this.value === LevelType.STOP_OUT.value) {
      return 'STOP_OUT'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!LevelType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!LevelType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!LevelType} Created enum
   */
  static fromObject (other) {
    return new LevelType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
LevelType.NONE = new LevelType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
LevelType.MARGIN_CALL = new LevelType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
LevelType.STOP_OUT = new LevelType(0 + 2)

export { LevelType };

/**
 * Fast Binary Encoding LevelType field model
 */
class FieldModelLevelType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelLevelType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelLevelType}
   * @param {LevelType=} defaults Default value, defaults is new LevelType()
   * @returns {!LevelType} Result value
   */
  get (defaults = new LevelType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new LevelType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelLevelType}
   * @param {!LevelType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelLevelType };
